<div class="container-fluid mt-3 ">
    <div class="row mt-3">
        <span class="ms-3 display-6 fw-bold">
            Heure de pointage
        </span>
    </div>
    <div class="border rounded-1 background-light mb-3 p-3">

        <div class="row">
            <mat-form-field class="col">
                <mat-label>Départ du domicile</mat-label>
                <input matInput [ngxTimepicker]="timepicker1" [value]="formatTime(DepartDomicile)" [format]="24" readonly>
                <ngx-material-timepicker #timepicker1 (timeSet)="timeSetDepartDomicile($event)"></ngx-material-timepicker>
                @if (DepartDomicile) {
                <button matSuffix mat-icon-button aria-label="Clear" (click)="clearDepartDomicile()">
                    <mat-icon class="material-symbols-outlined">close</mat-icon>
                </button>
                }
            </mat-form-field>
        </div>

        <div class="row">
            <mat-form-field class="col">
                <mat-label>Début de journée</mat-label>
                <input matInput [ngxTimepicker]="timepicker2" [value]="formatTime(DebutJournee)" [format]="24" readonly required>
                <ngx-material-timepicker #timepicker2 (timeSet)="timeSetDebutJournee($event)"></ngx-material-timepicker>
            </mat-form-field>
        </div>

        <div class="row">
            <mat-form-field class="col">
                <mat-label>Fin de journée</mat-label>
                <input matInput [ngxTimepicker]="timepicker3" [value]="formatTime(FinJournee)" [format]="24" readonly required>
                <ngx-material-timepicker #timepicker3 (timeSet)="timeSetFinJournee($event)"></ngx-material-timepicker>
            </mat-form-field>
        </div>

        <div class="row">
            <mat-form-field class="col">
                <mat-label>Arrivée au domicile</mat-label>
                <input matInput [ngxTimepicker]="timepicker4" [value]="formatTime(ArriveeDomicile)" [format]="24" readonly>
                <ngx-material-timepicker #timepicker4 (timeSet)="timeSetArriveeDomicile($event)"></ngx-material-timepicker>
                @if (ArriveeDomicile) {
                <button matSuffix mat-icon-button aria-label="Clear" (click)="clearArriveeDomicile()">
                    <mat-icon class="material-symbols-outlined">close</mat-icon>
                </button>
                }
            </mat-form-field>
        </div>

    </div>

    <div class="row">
        <span class="ms-3 display-6 fw-bold">
            Liste des pauses
        </span>
    </div>
    <div class="row border rounded-1 background-light mb-3 py-3">
        @for (p of Model?.PointagePauseList; track p) {
        <div class="g-0 row justify-content-between">
            <span class="col-1"></span>
            <span class="col-auto">{{p.Debut.toLocaleString(undefined, { hour: 'numeric', minute: 'numeric' })}} - {{p.Fin.toLocaleString(undefined, { hour: 'numeric', minute: 'numeric' })}}</span>
            <a class="col-auto btn-close" (click)="deletePause(p)"></a>
        </div>
        }
        <div class="row justify-content-center">
            <button class="col-auto" color="accent" mat-raised-button (click)="openPauseDialog()">
                Ajouter une pause
            </button>
        </div>
    </div>
    <div class="row mt-3">
        <button appPreventDoubleClick lass="col-12" color="primary" mat-raised-button (throttledClick)="save()">
            Enregistrer le pointage
        </button>
    </div>
</div>